export const CUSTOM_FONT_FETCH_SUCCESS = "CUSTOM_FONT_FETCH_SUCCESS";
export const CUSTOM_FONT_FETCH_FAILURE = "CUSTOM_FONT_FETCH_FAILURE";
export const CUSTOM_FONT_SAVE_SUCCESS = "CUSTOM_FONT_SAVE_SUCCESS";
export const CUSTOM_FONT_SAVE_FAILURE = "CUSTOM_FONT_SAVE_FAILURE";
export const CUSTOM_FONT_UPDATE_SUCCESS = "CUSTOM_FONT_UPDATE_SUCCESS";
export const CUSTOM_FONT_UPDATE_FAILURE = "CUSTOM_FONT_UPDATE_FAILURE";
export const CUSTOM_FONT_DELETE_SUCCESS = "CUSTOM_FONT_DELETE_SUCCESS";
export const CUSTOM_FONT_DELETE_FAILURE = "CUSTOM_FONT_DELETE_FAILURE";
export const UPDATE_USER_DEFAULT_FONT_SUCCESS = "UPDATE_USER_DEFAULT_FONT_SUCCESS";
export const UPDATE_USER_DEFAULT_FONT_FAILURE = "UPDATE_USER_DEFAULT_FONT_FAILURE";